<template>
    <div class="modal login">
        <!-- <div class="wrapper login__wrapper" :class="{'login__wrapper--tvp': isLoginTVP, 'login__wrapper--start': !isLoginTVP}"> -->
        <div class="wrapper login__wrapper login__wrapper--tvp">
            <IconClose class="close" @click="closeLoginModal"></IconClose>
            <LoginTVP></LoginTVP>
            <!-- <LoginStart v-if="!isLoginTVP" @showLoginTVP="showLoginTVP"></LoginStart>
            <LoginTVP v-if="isLoginTVP"></LoginTVP> -->
            <i class="letter-animal"></i>
        </div>
    </div>
</template>

<script>
// import LoginStart from "../login/LoginStart.vue";
import LoginTVP from "../login/LoginTVP.vue";
import IconClose from "../elements/icons/IconClose.vue";

export default {
    name: "ModalLogin",
    components: {
        LoginTVP, 
        // LoginStart,
        IconClose,
    },
    data() {
        return {
            // isLoginTVP: false,
        };
    },
    computed: {
        userData() {
            return this.$store.getters.getUserData;
        },
        isModalTimeLimit() {
            return this.$store.getters.getModalTimeLimit;
        }      
    },
    watch: {
        userData() {
            if(this.userData && this.userData.data && this.userData.data.email) {
                this.isLoginTVP = false;
            }
        }
    },
    methods: {
        closeLoginModal() {
            this.$store.dispatch("changeModalLoginState");
            if(!this.isModalTimeLimit) {
                this.$store.dispatch("changeModalBackdrop", false);
            } else {
                let modal = document.querySelector('.modal-backdrop');
                modal.classList.remove('login');
            }
        },
        showLoginTVP() {
            this.isLoginTVP = true;
        }
    }
};
</script>